import React from 'react';
import './Blogs.css';
import blog1 from '../../../images/blogs/blog1.png';
import blog2 from '../../../images/blogs/blog2.png';
import blog3 from '../../../images/blogs/blog3.png';


const Blogs = () => {
    return (
        <div className="Blogs">
            <div className="container py-5">
                <div className="header text-center">
                    <h2>MY LATEST <span>BLOG</span></h2>
                    {/* <p>I share the best ideas in my blog</p> */}
                    <div className="wrapper">
                        <div className="divider div-transparent div-dot"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={blog1} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">Everything to React at a glance for Beginners <span aria-label="" role="img"></span></h4>
                                <p className="card-text">React (also known as React.js or ReactJS) is an open-source, front end, JavaScript library for building user interfaces or UI components. It is maintained by Facebook.</p>
                                <a href="https://nurmuhammad111.medium.com/everything-to-react-at-a-glance-for-beginners-2a546407ef6a" target="_blank" rel="noopener noreferrer" className="btn">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={blog2} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">HTML5 Interview Questions & Answers<span aria-label="" role="img"></span></h4>
                                <p className="card-text">A list of top frequently asked HTML interview questions and HTML5 interview questions and answers are given below.</p>
                                <a href="https://nurmuhammad111.medium.com/top-60-html-html5-interview-questions-answers-232abf5cf713" target="_blank" rel="noopener noreferrer" className="btn">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={blog3} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">Javascript Interview Questions<span aria-label="" role="img"></span></h4>
                                <p className="card-text">JavaScript is a scripting or programming language that allows you to implement complex features on web pages — every time a web page ...</p>
                                <a href="https://nurmuhammad111.medium.com/javascript-interview-questions-dd6ee8982740" target="_blank" rel="noopener noreferrer" className="btn">Read More</a>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default Blogs;